import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Stack from 'react-bootstrap/Stack';


const chatLoading = () => {
    return (
      <Stack gap={3}>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0rem", height : "2.5rem", borderRadius : "1rem"}}></div>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0px", height : "2.5rem", borderRadius : "1rem"}}></div>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0px", height : "2.5rem", borderRadius : "1rem"}}></div>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0px", height : "2.5rem", borderRadius : "1rem"}}></div>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0px", height : "2.5rem", borderRadius : "1rem"}}></div>
      <div className="p-2" style = {{backgroundColor : "rgba(185, 176, 176, 0.612)",marginbottom : "1rem", marginLeft : "2rem", marginRight : "2rem", marginTop : "0px", height : "2.5rem", borderRadius : "1rem"}}></div>
    </Stack>
      );
}

export default chatLoading
